<table>
    <tbody>
        @for (kpiPoint of points; track $index) {
        <tr>
            <td class="dp-name">
                <div
                    [ngClass]="{
                        'is-overridden':
                            kpiPoint?.isWritable && kpiPoint?.isOverridden
                    }"
                >
                    <span
                        >{{
                            kpiPoint?.comment ||
                                kpiPoint?.sourceDescription ||
                                kpiPoint?.classLabel
                        }}</span
                    >
                </div>
            </td>
            <td class="wifi-status-icon">
                <div class="flex align-items-center">
                    @if (isPointOffline(kpiPoint?.pointUUID)) {
                    <mat-icon
                        class="header-icon cbms-red-color"
                        svgIcon="wifi_off"
                        pTooltip="This determines the data points are missing and / or flatlining. Please check in detailed view and history graph."
                    >
                    </mat-icon>
                    }
                </div>
            </td>
            <td class="point-overiden-icon">
                <div>
                    <!--overridden point - lock button/icon -->
                    @if (kpiPoint?.isWritable && kpiPoint?.isOverridden) {
                    <i
                        class="pi pi-lock is-overridden"
                        pTooltip="Point Overridden"
                        (click)="openResetConfirmationDialog(kpiPoint)"
                    ></i>
                    }
                </div>
            </td>
            <td class="dp-value">
                @if (kpiPoint?.lastRecordedValueMask) {
                {{ kpiPoint?.lastRecordedValueMask }}
                } @else { @if (kpiPoint?.signalType === BINARY) { @if
                (kpiPoint?.presentValue) { On } @if (!kpiPoint?.presentValue) {
                Off } } @else {
                <!--NON-BINARY POINT controls-->
                {{ kpiPoint?.presentValue }}

                } }
            </td>
            <td class="html-symbol">
                <span [innerHTML]="kpiPoint?.htmlSymbol"></span>
            </td>
            <td class="edit-dp-value">
                @if (kpiPoint?.isWritable && userHasWritePermission) {
                <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="ui-button-info cbms-button-edit"
                    (click)="editDataPointValue(kpiPoint)"
                ></button>
                }
            </td>
        </tr>
        }
    </tbody>
</table>
